import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TLabelChat } from '../types/label-chat.type';

/**
 *
 */
export const deleteLabelChatValidationSchema = z.object({
  labelChatId: z.string().min(1, { message: 'Label Chat ID is required' }),
});

export type TDeleteLabelChatValidation = z.infer<typeof deleteLabelChatValidationSchema>;
export type TDeleteLabelChatPayload = TDeleteLabelChatValidation;
export type TDeleteLabelChatResponse = ApiResponse<TLabelChat>;

export const deleteLabelChat = async (data: TDeleteLabelChatPayload): Promise<TDeleteLabelChatResponse> => {
  const url = `/label-chat/${data.labelChatId}`;

  return axiosInstance.delete(url);
};

/**
 *
 */
type TUseDeleteLabelChatMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof deleteLabelChat, AxiosErrorCustom>;
};

export const useDeleteLabelChatMutation = ({ mutationConfigOptions }: TUseDeleteLabelChatMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: deleteLabelChat,
    ...restConfigOptions,
  });
};
